import { CustomerConfigurationGateway } from './customer-configuration-gateway.interface';

export const initCustomerConfigurationAPI = (
  apiSlice: any,
  gateway: CustomerConfigurationGateway
) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['CustomerConfigurations', 'Notification'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        patchCustomerConfigurations: builder.mutation({
          query: gateway.patchCustomerConfigurations,
          invalidatesTags: ['Notification', 'Project'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface CustomerConfigurationSliceType {
  usePatchCustomerConfigurationsMutation: Function;
}
